$(document).ready(function() {
    $(document).on('click', '.js-modal-close', function() {
        if (!($('.b-header').hasClass('menu'))) {
            $('body').removeClass('is-modal-open');
        }
        $('.b-header').removeClass('modal');
        $('.b-modal').hide();
    });
    $('body').on('click', function(e) {
    	if (!(e.target).closest('.b-modal__content') && !(e.target).closest('.b-menu')
            && !(e.target).closest('.b-full-screen') && !(e.target).closest('.b-header')
            && !(e.target).closest('.js-preorder-bonus-content')) {
            if (!($('.b-header').hasClass('menu'))) {
                $('body').removeClass('is-modal-open');
            }
            $('.b-header').removeClass('auth');
	        $('.b-modal').hide();
    	}
    });
});



// WEBPACK FOOTER //
// ./src/js/general/modal.js